import axios from "axios";
import { GlobalResType } from "DataTypes/Common";
import { setAlertData } from "../Redux/Screen/Action";
import { store } from "../Redux/Store";
import { Admin_Number, CheckStringEmpty } from "Utils/Common";

export const get = (request: any) => {
  return commonFetch({ method: "get", ...request });
};

export const post = (request: any) => {
  return commonFetch({ method: "post", ...request });
};

export const patch = (request: any) => {
  return commonFetch({ method: "patch", ...request });
};

export const put = (request: any) => {
  return commonFetch({ method: "put", ...request });
};

export const deletee = (request: any) => {
  return commonFetch({ method: "delete", ...request });
};

export const abortSignal = axios.CancelToken.source();

// const commonFetch: (request: any) => any = (request: any) => {
//   const dispatch = store.dispatch;
//   try {
//     const {
//       subUrl,
//       method,
//       data = {},
//       params = {},
//       headers = {},
//       isAuth,
//       isPayment,
//       isChat,
//       excel,
//       dataType = "json",
//     } = request;

//     let url;
//     const baseUrlAuth = process.env.REACT_APP_BASE_URL;
//     if (isAuth) url = `${baseUrlAuth}/api/Auth/${subUrl}`;
//     else if (isPayment) url = `${baseUrlAuth}/api/Payments/${subUrl}`;
//     else if (isChat) url = `${baseUrlAuth}/api/Chat/${subUrl}`;
//     else url = `${baseUrlAuth}/api/${subUrl}`;

//     const passedHeaders = headers;
//     const commonHeaders = getCommonHeaders(excel, dataType);
//     const responseType = excel ? "blob" : "json";
//     return axios({
//       method,
//       url,
//       responseType,
//       data,
//       withCredentials: false,
//       headers: excel
//         ? { ...commonHeaders }
//         : { ...commonHeaders, ...passedHeaders },
//       params,
//     })
//       .then((response) => {
//         return {
//           success: true,
//           data: response?.data,
//           alert: {
//             alertMessage: response?.data?.message || "",
//             openAlert: response?.data?.message ? true : false,
//             alertVariant: "success",
//           },
//         };
//       })
//       .catch((error) => {
//         console.log("error --------> ", error);
//         if (error?.response?.status === 400) {
//           console.log("error?.response?.data?.title", error?.response?.data?.title);
//           //   Dispatch Error Unable to perform this action. Please try after sometime.
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 401) {
//           // Handle Session (Error  Session has expired. Please log in again.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 403) {
//           //   handle Authorization Error (You are not authorized to perform this action.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 404) {
//           //   Handle Resource Not Found Error (Resource not found. Please try after sometime.)
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else if (error?.response?.status === 500) {
//           // Handle Something went wrong. Please login after sometime
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         } else {
//           // Handle Something went wrong. Please login after sometime
//           dispatch(
//             setAlertData({
//               alertMessage: CheckStringEmpty(error?.response?.data?.title),
//               openAlert: true,
//               alertVariant: "error",
//             })
//           );
//           return {
//             success: false,
//             data: null,
//             alert: {
//               alertMessage: "",
//               openAlert: false,
//               alertVariant: "error",
//             },
//           };
//         }
//       });
//   } catch (err) {
//     // Handle Error Here
//     return {
//       success: true,
//       data: null,
//       alert: {
//         alertMessage: "",
//         openAlert: false,
//         alertVariant: "error",
//       },
//     };
//   }
// };

const commonFetch: (request: any) => any = (request: any) => {
  const dispatch = store.dispatch;
  try {
    const {
      subUrl,
      method,
      data = {},
      params = {},
      headers = {},
      isAuth,
      isPayment,
      isChat,
      isTwilio,
      excel,
      dataType = "json",
    } = request;

    const baseUrlAuth = process.env.REACT_APP_BASE_URL;

    const url = isAuth
      ? `${baseUrlAuth}/api/Auth/${subUrl}`
      : isPayment
      ? `${baseUrlAuth}/api/Payments/${subUrl}`
      : isChat
      ? `${baseUrlAuth}/api/Chat/${subUrl}`
      : isTwilio
      ? `${baseUrlAuth}/api/ConferenceCall/${subUrl}`
      : `${baseUrlAuth}/api/${subUrl}`;

    const commonHeaders = getCommonHeaders(excel, dataType);
    console.log("common Headers are ", commonHeaders);
    const responseType = excel ? "blob" : "json";

    return axios({
      method,
      url,
      responseType,
      data,
      withCredentials: false,
      headers: excel ? { ...commonHeaders } : { ...commonHeaders, ...headers },
      params,
    })
      .then((response) => {
        console.log(response, "response");
        return {
          success: true,
          data: response?.data,
          alert: {
            alertMessage: response?.data?.message || "",
            openAlert: response?.data?.message ? true : false,
            alertVariant: "success",
          },
        };
      })
      .catch((error) => {
        //  Prepare default error message
        const status = error?.response?.status;
        const title =
          CheckStringEmpty(error?.response?.data?.title) ||
          `Something went wrong. Please contact administrator. ${Admin_Number}`;

        if ([400, 401, 403, 404, 500].includes(status)) {
          dispatch(
            setAlertData({
              alertMessage: title,
              openAlert: true,
              alertVariant: "error",
            })
          );
        } else {
          // Unknown or network error
          dispatch(
            setAlertData({
              alertMessage: title,
              openAlert: true,
              alertVariant: "error",
            })
          );
        }

        return {
          success: false,
          data: null,
          alert: {
            alertMessage: "",
            openAlert: false,
            alertVariant: "error",
          },
        };
      });
  } catch (err) {
    return {
      success: false,
      data: null,
      alert: {
        alertMessage: "Unexpected error occurred.",
        openAlert: true,
        alertVariant: "error",
      },
    };
  }
};

const getCommonHeaders = (excel: any, dataType: "json" | "form-data") => {
  const localToken = localStorage.getItem("token") || "";
  const tokenStorage = localToken ? JSON.parse(JSON.stringify(localToken)) : "";

  const headerObj = {
      Accept: "*/*", 
    "Content-Type":
      dataType === "form-data" ? "multipart/form-data" : "application/json",
    "Access-Control-Allow-Origin": true,
    Authorization: tokenStorage ? `Bearer ${tokenStorage}` : "",
  };
  const headerObjForExcel = {
    Authorization: tokenStorage ? `Bearer ${tokenStorage}` : "",
  };
  return excel ? headerObjForExcel : headerObj;
};

export const upload = (request: any) => {
  const dispatch = store.dispatch;

  try {
    const {
      subUrl,
      method = "post",
      data,
      params = {},
      headers = {},
      isAuth,
      isPayment,
      forceContentType = false,
    } = request;

    let url = "";
    const baseUrlAuth = process.env.REACT_APP_BASE_URL;

    if (isAuth) url = `${baseUrlAuth}/api/Auth/${subUrl}`;
    else if (isPayment) url = `${baseUrlAuth}/api/Payments/${subUrl}`;
    else url = `${baseUrlAuth}/api/${subUrl}`;

    const token = localStorage.getItem("cm-token");
    const tokenStorage = token ? JSON.parse(token) : "";

    // ⚠️ Build headers without forcing Content-Type
    const authHeaders = {
      Authorization: tokenStorage ? `Bearer ${tokenStorage}` : "",
      ...headers,
    };

    if (forceContentType) {
      authHeaders["Content-Type"] = "multipart/form-data";
    }

    return axios({
      method,
      url,
      data,
      params,
      headers: authHeaders,
      // DO NOT set `withCredentials: false` — axios default is fine
    })
      .then((response) => {
        return {
          success: true,
          data: response?.data,
          alert: {
            alertMessage: response?.data?.message || "",
            openAlert: !!response?.data?.message,
            alertVariant: "success",
          },
        };
      })
      .catch((error) => {
        dispatch(
          setAlertData({
            alertMessage: error?.response?.data?.title || "Upload failed.",
            openAlert: true,
            alertVariant: "error",
          })
        );
        return {
          success: false,
          data: null,
          alert: {
            alertMessage: "",
            openAlert: false,
            alertVariant: "error",
          },
        };
      });
  } catch (err) {
    return {
      success: false,
      data: null,
      alert: {
        alertMessage: "",
        openAlert: false,
        alertVariant: "error",
      },
    };
  }
};
